import {
  getAdminV1OrgAuditLogs,
  type GetAdminV1OrgAuditLogs200,
  type GetAdminV1OrgAuditLogsParams,
} from '@nucleus-commerce/api-client/admin';

/** The organisation's audit trail, newest first, cursor-paged. Needs audit.read. */
export const activityApi = {
  list: (params: GetAdminV1OrgAuditLogsParams): Promise<GetAdminV1OrgAuditLogs200> =>
    getAdminV1OrgAuditLogs(params),
};
